import * as S from './styled';
import { webSocketApiUrlsDictionary } from '../../../constants';

const AnalyticsPage = () => {
  const theme = localStorage.getItem('theme');

  const bi_url =
    webSocketApiUrlsDictionary[theme]?.biUrl || process.env.REACT_APP_BI_URL;

  if (!bi_url) {
    return <></>;
  }

  return (
    <S.IframeWrapper>
      <iframe
        title='BI'
        width='900'
        height='373.5'
        src={bi_url}
        frameborder='0'
        allowFullScreen='true'
      ></iframe>
    </S.IframeWrapper>
  );
};

export default AnalyticsPage;
